import { useState } from "react";
import { useLocation } from "react-router-dom";
import Static from "./Static";
import Live from "./Live";

export default function StaticWithLive({ contentHeight, camera }) {

    const location = useLocation()

    const [showLive, setShowLive] = useState(() => {
        const liveCamId = location.state?.liveCamId
        if (liveCamId === undefined || liveCamId === null) return true
        return liveCamId === camera?.id
    })

    const handleStaticLiveSwitch = () => {
        setShowLive(!showLive)
    }

    if (showLive) {
        return (
            <Live
                contentHeight={contentHeight}
                camera={camera}
                handleStaticLiveSwitch={handleStaticLiveSwitch}
            />
        )
    } else {
        return (
            <Static
                contentHeight={contentHeight}
                camera={camera}
                handleStaticLiveSwitch={handleStaticLiveSwitch}
            />
        )
    }
}